import { Controller } from "@hotwired/stimulus"

// Persists TABLE SORTING state in Rails session (server-side), never in URL params.
// Sort links provide desired column/direction via data attributes.
export default class extends Controller {
  static values = {
    endpoint: { type: String, default: "/ui/sort_preferences" }
  }

  async sort(event) {
    event.preventDefault()

    const link = event.currentTarget
    const column = link.dataset.sortColumn
    const direction = link.dataset.sortDirection
    const key = link.dataset.sortKey

    if (!column || !direction || !key) {
      Turbo.visit(link.href)
      return
    }

    try {
      await this.persistSort({ key, column, direction })
    } catch (_) {
      // Ignore and still navigate; server will keep previous/default sort
    }

    Turbo.visit(link.href, { action: "replace" })
  }

  async persistSort(payload) {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    const response = await fetch(this.endpointValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify(payload)
    })

    if (!response.ok) {
      throw new Error(`Failed to persist sort: ${response.status}`)
    }
  }
}
